/**
 * TodoPage — 나의 할일 (D-1 오늘 /todo · D-2 7일 /todo/week). GET /schedule/todos?scope=week.
 * 탭 전환은 경로 이동으로 처리한다. 레이아웃은 D-07 §21.5 L2 광폭 doc(xl).
 * .page-doc 가 main 높이를 채우므로(min-height 100%) flex 열로 두어 오류·빈 상태 블록이 본문 영역 세로 중앙에 오게 한다.
 */
import { useNavigate } from 'react-router';
import { Page } from '@indipia/ui-core';
import { TodoBoard, type TodoTab } from '../todo/TodoBoard';

export function TodoPage({ tab }: { tab: TodoTab }) {
  const navigate = useNavigate();
  return (
    <Page width="xl" className="flex flex-col">
      <TodoBoard tab={tab} onTabChange={(t) => navigate(t === 'week' ? '/todo/week' : '/todo')} />
    </Page>
  );
}
